<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <driver-control></driver-control>
      <driver-view></driver-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import DriverControl from "@/components/drivers/driverControl";
import DriverView from "@/components/drivers/driverView";

export default {
  data() {
    return {
      fid: Number(this.$route.query.fid)
    };
  },
  methods: {},
  computed: {
    contractor: Store.getSet({ store: "drivers", prop: "contractor" })
  },
  mounted() {
    !!this.fid && (this.contractor = this.fid);
  },
  components: {
    DriverControl,
    DriverView
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
